const ORIGIN_QUEST_KEY = 'single-quest-origin';

export { ORIGIN_QUEST_KEY };
